import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export const getAreaCountry = createAsyncThunk(
  'hunting/getAreaCountry',
  async (p, store: any) => {
    const resp = await http.post('/live/union/get_countrys_by_area_code', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

export const getAreaPolicy = createAsyncThunk(
  'hunting/getAreaPolicy',
  async (p, store: any) => {
    const resp = await http.post('/live/union/get_area_policy', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

// 获取swipper图片信息 http://wiki.xunlei.cn/pages/viewpage.action?pageId=100429514
export const getBannerImg = createAsyncThunk(
  'hunting/getMainBanner',
  async (p, store: any) => {
    const resp = await http.post('/live/union/bd_banners', {
      ...store.getState().env.deviceinfo,
      kind: 1,
    })
    return resp.data
  }
)

// 发送邀请链接 http://wiki.xunlei.cn/pages/viewpage.action?pageId=100429521
export const getInviteSend = createAsyncThunk(
  'hunting/getInviteSend',
  async (p: {from_mid: number; to_mid: number}, store: any) => {
    const resp = await http.post('/live/union/common_invite', {
      ...store.getState().env.deviceinfo,
      ...p,
      kind: 1,
    })
    return resp.data
  }
)

// 邀请记录 http://wiki.xunlei.cn/pages/viewpage.action?pageId=100433028
export const getInviteList = createAsyncThunk(
  'hunting/getInviteList',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/get_common_invite_list', {
      ...store.getState().env.deviceinfo,
      ...p,
      kind: 1,
      from: 'invite',
    })
    return resp.data
  }
)

// 公会直播情况 http://wiki.xunlei.cn/pages/viewpage.action?pageId=104333362
export const getUnionList = createAsyncThunk(
  'hunting/getUnionList',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/get_bu_list', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export const getBDUnionList = createAsyncThunk(
  'hunting/getBDUnionList',
  async (p, store: any) => {
    const resp = await http.post('/live/union/get_bd_unions', {
      ...store.getState().env.deviceinfo,
      offset: store.getState().Hunting.unionHistory.offset,
      limit: 30,
    })
    return resp.data
  }
)
export const inviteUnion = createAsyncThunk(
  'hunting/inviteUnion',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/union/bd_add_invite_union',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcHideLog: true,
      }
    )
    return resp.data
  }
)
export const getBDurlInfo = createAsyncThunk(
  'hunting/getBDurlInfo',
  async (p, store: any) => {
    const resp = await http.post('/live/union/get_invite_bd_info', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)
export const getChatApps = createAsyncThunk(
  'hunting/getChatApps',
  async (p, store: any) => {
    const resp = await http.post('/live/union/get_invite_bd_info', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

export const acceptToBeBD = createAsyncThunk(
  'hunting/acceptToBeBD',
  async (p: any, store: any) => {
    const resp = await http.post(
      'live/union/check_and_accept_bd',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcHideLog: true,
      }
    )
    return resp.data
  }
)

export const getMemberInfo = createAsyncThunk(
  'hunting/getMemberInfo',
  async (p: {show_id: string}, store: any) => {
    const resp = await http.post('live/account/get_member_info_by_show_id', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export const getMemberInfoByMid = createAsyncThunk(
  'hunting/getMemberInfoByMid',
  async (p: {mid: number}, store: any) => {
    const resp = await http.post('live/account/simple_member_by_mid', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)
// http://wiki.xunlei.cn/pages/viewpage.action?pageId=120401941
export const vip_level_info = createAsyncThunk(
  'hunting/live/vip/level_info',
  async (p, store: any) => {
    const resp = await http.post('/live/vip/level_info', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

export const inviteRicher = createAsyncThunk(
  'hunting/inviteRicher',
  async (p: {show_id: string; from: string}, store: any) => {
    const resp = await http.post('live/union/bd_invite_richer', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export const getRicherList = createAsyncThunk(
  'hunting/getRicherList',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/richer_list', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export const getBdInfo = createAsyncThunk(
  'hunting/getBdInfo',
  async (p, store: any) => {
    const resp = await http.post('/live/union/get_bd_info', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

export const unionConfirm = createAsyncThunk(
  'hunting/unionConfirm',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/union_confirm', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export const richerConfirm = createAsyncThunk(
  'hunting/richerConfirm',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/richer_confirm', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// 分销商确认 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92470012
export const distributorConfirm = createAsyncThunk(
  'hunting/distributorConfirm',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/distributor_confirm', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

interface HuntintUnionState {
  country_list: Array<{country_code: number; country: string}>
  img_list: Array<{cover: string; link: string}>
  area_policy: string
  img_url: string
  richer_area_policy: string
  richer_img_url: string
  unionHistory: {
    list: Array<any>
    more: boolean
    offset: number
  }
  unionInviteList: {
    list: Array<any>
    // more: boolean
    offset: number
  }
  bdurlInfo: {
    chat_apps: Array<string>
    is_expire: boolean
  }
  chat_apps: string[]
  richer_status: number
  union_status: number
  invite: {
    show_id: string
    avatar_url: string
    name: string
  }
  inviteMid: {
    show_id: string
    avatar_url: string
    name: string
  }
  vip_level_info?: {
    has_limit: boolean
    limit_level: number
    vip_level: number
  }
}
const initialState: HuntintUnionState = {
  country_list: [],
  img_list: [],
  area_policy: '',
  img_url: '',
  richer_area_policy: '',
  richer_img_url: '',
  unionInviteList: {
    list: [],
    // more: true,
    offset: 0,
  },
  unionHistory: {
    list: [
      // {
      //   name: 'Allin',
      //   status: 1,
      //   statistics_st: '2022-3-23',
      //   coins: 772,
      //   statistics_status: 2,
      // },
    ],
    more: true,
    offset: 0,
  },
  bdurlInfo: {
    chat_apps: [],
    is_expire: false,
  },
  chat_apps: [],
  richer_status: 1,
  union_status: 1,
  invite: {
    show_id: '',
    avatar_url: '',
    name: '',
  },
  inviteMid: {
    show_id: '',
    avatar_url: '',
    name: '',
  },
  // BdBannerSt: {
  //   Link: '',
  // },
}
export const HuntingSlice = createSlice({
  name: 'Hunting',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAreaCountry.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, {country_list: data || []})
    })
    builder.addCase(getAreaPolicy.fulfilled, (state, action) => {
      const {
        data: {
          area_policy = '',
          img_url = '',
          richer_area_policy = '',
          richer_img_url = '',
        } = {},
      } = action.payload
      Object.assign(state, {
        area_policy,
        img_url,
        richer_area_policy,
        richer_img_url,
      })
    })
    builder.addCase(getBDUnionList.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, {
        unionHistory: {
          ...data,
          list: [...state.unionHistory.list, ...(data.list || [])],
        },
      })
    })
    builder.addCase(getBDurlInfo.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, {bdurlInfo: data})
    })
    builder.addCase(getChatApps.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, {chat_apps: data.chat_apps})
    })
    builder.addCase(getBdInfo.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, {
        richer_status: data.richer_status,
        union_status: data.status,
      })
    })
    builder.addCase(getMemberInfo.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state.invite, data)
    })
    builder.addCase(getMemberInfoByMid.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state.inviteMid, data)
    })
    builder.addCase(getBannerImg.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, {img_list: data.list || []})
    })
    builder.addCase(getInviteList.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, {
        unionInviteList: {
          ...data,
          list: [...state.unionInviteList.list, ...(data.list || [])],
        },
      })
    })
    builder.addCase(vip_level_info.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, {vip_level_info: data})
    })
    // .addCase(getInviteSend.fulfilled, (state, action) => {
    //   const {data} = action.payload
    //   Object.assign(state, {})
    // })
  },
})

export default HuntingSlice.reducer
